import { Tabs as AntTabs } from "antd";
import type { TabsProps as AntTabsProps } from "antd";

export interface TabProps extends AntTabsProps {
  children?: React.ReactNode;
}

export function Tabs({ children, ...props }: TabProps) {
  return <AntTabs {...props}>{children}</AntTabs>;
}
